module.exports = __webpack_public_path__ + "img/rocket.441451f8.svg";